import baseApi from "./baseApiService";
import { API_CONSTANTS } from "../../constants/apiConstants";

export const checkApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSocietyById: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_SOCIETY_BY_ID}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getAllcounts: builder.query({
      query: () => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_ALL_COUNTS}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getRecentAwardees: builder.query({
      query: (filterCriteria) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_RECENT_AWARDEES}`,
          method: "POST",
          body: JSON.stringify(filterCriteria),
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        };
      },
    }),
    getAwards: builder.query({
      query: (filterCriteria) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_ALL_AWARDS}`,
          method: "POST",
          body: JSON.stringify(filterCriteria),
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        };
      },
    }),
    getNetworkGraphCounts: builder.query({
      query: (awardIds) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_NETWORK_GRAPH_COUNTS}`,
          method: "POST",
          body: JSON.stringify(awardIds),
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        };
      },
    }),
    getNetworkGraphAwardees: builder.query({
      query: (awardIds) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_NETWORK_GRAPH_AWARDEES}`,
          method: "POST",
          body: JSON.stringify(awardIds),
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        };
      },
    }),
    getAwardeeById: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARDEE_BY_ID}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getUTAFacultyById: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_UTA_FACULTY_BY_ID}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getAwardsBySocietyNumber: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARDS_BY_SOCIETY_NUMBER}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getAwardsBySearchString: builder.query({
      query: (searchString) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARDS_BY_SEARCH_STRING}/${searchString}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getAllSocieties: builder.query({
      query: () => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_ALL_SOCIETIES}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getSocitiesBySearchString: builder.query({
      query: (searchString) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_SOCIETIES_BY_SEARCH_STRING}/${searchString}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getAwardeeByIdName: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARDEE_BY_ID_NAME}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getAwardeGraphById: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARD_GRAPH_ID}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    // Live gender split from awardees.sex - async fallback used only when
    // neither the AwardYears bars nor the PercentageWomen pie has data.
    getAwardGenderCompute: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARD_GENDER_COMPUTE}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    // Award detail by id - refresh-safe replacement for the old location.state
    // hand-off (GET /api/award/:id already exists on the backend).
    getAwardById: builder.query({
      query: (id) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARD_BY_ID}/${id}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    // Advanced-search dropdown data (Category / Level vocab + Kind buckets).
    // Static for a session, so a plain cached query is enough.
    getAwardFilterOptions: builder.query({
      query: () => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_AWARD_FILTER_OPTIONS}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    // Organization typeahead - fetched lazily as the user types in Advanced.
    getOrganizationOptions: builder.query({
      query: (term) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${
            API_CONSTANTS.GET_ORGANIZATION_OPTIONS
          }?q=${encodeURIComponent(term || "")}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getUtaFacultyMasterData: builder.query({
      query: () => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_UTA_FACULTY_MASTER_DATA}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
    getModelData: builder.query({
      query: (input) => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_MODEL_DATA}`,
          method: "POST",
          body: JSON.stringify(input),
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        };
      },
    }),
    getClientNetwork: builder.query({
      query: () => {
        return {
          url: `${API_CONSTANTS.BASE_URL}${API_CONSTANTS.GET_CLIENT_NETWORK}`,
          method: "GET",
          headers: {
            "Content-Type": "*/*",
            Accept: "*/*",
          },
        };
      },
    }),
  }),
});
export const {
  useLazyGetAwardsQuery,
  useGetRecentAwardeesQuery,
  useLazyGetRecentAwardeesQuery,
  useGetAllcountsQuery,
  useLazyGetAwardeeByIdQuery,
  useLazyGetAwardeeByIdNameQuery,
  useGetUtaFacultyMasterDataQuery,
  useLazyGetUTAFacultyByIdQuery,
  useLazyGetAwardsBySearchStringQuery,
  useLazyGetNetworkGraphCountsQuery,
  useLazyGetNetworkGraphAwardeesQuery,
  useLazyGetSocietyByIdQuery,
  useGetAllSocietiesQuery,
  useLazyGetSocitiesBySearchStringQuery,
  useLazyGetAwardsBySocietyNumberQuery,
  useLazyGetAwardeGraphByIdQuery,
  useLazyGetAwardGenderComputeQuery,
  useGetAwardByIdQuery,
  useLazyGetAwardByIdQuery,
  useGetAwardFilterOptionsQuery,
  useLazyGetOrganizationOptionsQuery,
  useLazyGetModelDataQuery,
  useGetClientNetworkQuery,
} = checkApi;
